import { render, staticRenderFns } from "./ServeDetailData.vue?vue&type=template&id=f11ecf8a&scoped=true&"
import script from "./ServeDetailData.vue?vue&type=script&lang=js&"
export * from "./ServeDetailData.vue?vue&type=script&lang=js&"
import style0 from "./ServeDetailData.vue?vue&type=style&index=0&id=f11ecf8a&lang=scss&scoped=true&"
import style1 from "./ServeDetailData.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11ecf8a",
  null
  
)

export default component.exports